module.exports = __webpack_public_path__ + "static/logo-b6e4792b59b6d3915faab9d449df918f.svg";